import clsx from "clsx";
import { forwardRef } from "react";
import { twMerge } from "tailwind-merge";
import type { ControlSize } from "../types";
import { controlGroupSizeStyles } from "./styles";

export interface ControlGroupParticipantProps extends React.HTMLAttributes<HTMLDivElement> {
  grow?: boolean;
  size?: ControlSize;
}

const ControlGroupParticipant = forwardRef<
  HTMLDivElement,
  ControlGroupParticipantProps
>(({ className, grow, size, style, ...props }, ref) => (
  <div
    {...props}
    ref={ref}
    style={{ ...(size ? controlGroupSizeStyles[size] : undefined), ...style }}
    className={twMerge(
      clsx(
        "control-group-participant flex min-w-0 items-stretch",
        grow && "flex-1",
      ),
      className,
    )}
  />
));

export default ControlGroupParticipant;
